// navigation.js
// Utility for remembering and restoring the user's previous page (for checkout/payment flows)

export function rememberCurrentPage() {
  if (typeof window !== 'undefined' && window.location) {
    localStorage.setItem('podvault_prev_page', window.location.pathname + window.location.search);
  }
}

export function getRememberedPage(defaultPage = '/') {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('podvault_prev_page') || defaultPage;
  }
  return defaultPage;
}

export function clearRememberedPage() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('podvault_prev_page');
  }
}
